import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';

import CountUp from 'react-countup';

const Whyus = () => {

  return (
    <>
      {/*==========================
    Why Us Section
  ============================*/}
      <section id="why-us" className="wow fadeIn">
        <div className="container">
          <header className="section-header">
            <h3>Why choose us?</h3>
            <p>
              Choose us for expert website, mobile app, computer and laptop
              solutions backed by personalized service and a commitment to
              customer satisfaction
            </p>
          </header>

          <div className="row row-eq-height justify-content-center">
            <div className="col-lg-6 mb-6">
              <div className="card wow bounceInUp">
                <div className="card-body">
                  <h5 className="card-title">Expertise:</h5>
                  <p className="card-text">
                    Our team comprises experienced professionals with extensive
                    knowledge of computer hardware, software, and
                    troubleshooting techniques.
                  </p>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Personalized Service:</h5>
                  <p className="card-text">
                    We prioritize personalized service, taking the time to
                    understand each customer's unique needs and preferences.
                  </p>
                </div>

                <div className="card-body">
                  <h5 className="card-title">Competitive Pricing: </h5>
                  <p className="card-text">
                    We strive to offer competitive pricing without compromising
                    on quality, providing excellent value for your investment.
                  </p>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Trusted Reputation: </h5>
                  <p className="card-text">
                    With a strong track record of satisfied customers and
                    positive reviews, you can trust us to deliver exceptional
                    service every time.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-6">
              <div className="card wow bounceInUp">
                <div className="card-body">
                  <h5 className="card-title">Quality Products: </h5>
                  <p className="card-text">
                    We offer a curated selection of high-quality computers and
                    laptops from trusted brands, ensuring durability and
                    performance.
                  </p>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Comprehensive Solutions: </h5>
                  <p className="card-text">
                    From sales to repairs and upgrades, we provide end-to-end
                    solutions to meet all your computing needs under one roof.
                  </p>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Customer Satisfaction: </h5>
                  <p className="card-text">
                    Our commitment to customer satisfaction drives everything we
                    do, ensuring a smooth and satisfactory experience for every
                    client.
                  </p>
                </div>
                <div className="card-body">
                  <h5 className="card-title">Timely Support: </h5>
                  <p className="card-text">
                    We understand the importance of timely support, offering
                    quick turnaround times for repairs and assistance whenever
                    you need it.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row row-eq-height justify-content-center">

        <div className="col-lg-4 mb-4">
          <div className="card wow bounceInUp">
              <i className="fa fa-diamond"></i>
            <div className="card-body">
              <h5 className="card-title">Corporis dolorem</h5>
              <p className="card-text">Deleniti optio et nisi dolorem debitis. Aliquam nobis est temporibus sunt ab inventore officiis aut voluptatibus.</p>
              <a href="#" className="readmore">Read more </a>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-4">
          <div className="card wow bounceInUp">
              <i className="fa fa-language"></i>
            <div className="card-body">
              <h5 className="card-title">Voluptates dolores</h5>
              <p className="card-text">Voluptates nihil et quis omnis et eaque omnis sint aut. Ducimus dolorum aspernatur.</p>
              <a href="#" className="readmore">Read more </a>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mb-4">
          <div className="card wow bounceInUp">
              <i className="fa fa-object-group"></i>
            <div className="card-body">
              <h5 className="card-title">Eum ut aspernatur</h5>
              <p className="card-text">Autem quod nesciunt eos ea aut amet laboriosam ab. Eos quis porro in non nemo ex. </p>
              <a href="#" className="readmore">Read more </a>
            </div>
          </div>
        </div>

      </div> */}

          <div className="row counters">
            <div className="col-lg-3 col-6 text-center">
              <span data-toggle="counter-up">
                <CountUp
                  enableScrollSpy={true}
                  scrollSpyOnce={false}
                  end={4}
                />
              </span>
              <p>Clients</p>
            </div>

            <div className="col-lg-3 col-6 text-center">
              <span data-toggle="counter-up">
                <CountUp
                  enableScrollSpy={true}
                  scrollSpyOnce={false}
                  end={4}
                />
              </span>
              <p>Projects</p>
            </div>

            <div className="col-lg-3 col-6 text-center">
              <span data-toggle="counter-up">
                <CountUp
                  enableScrollSpy={true}
                  scrollSpyOnce={false}
                  end={640}
                />
              </span>
              <p>Hours of Support</p>
            </div>

            <div className="col-lg-3 col-6 text-center">
              <span data-toggle="counter-up">
                <CountUp
                  enableScrollSpy={true}
                  scrollSpyOnce={false}
                  end={4}
                />
              </span>
              <p>Hard workers</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Whyus;